const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4007";
export default apiUrl;
